export const SORT_TYPE = {
  CREATED_AT_FIRST: 'CREATED_AT_FIRST',
  UNADDRESSED_FIRST: 'UNADDRESSED_FIRST',
} as const;

export const CASE_AVAILABILITY_FILTER = {
  UNASSIGNED_ONLY: 'UNASSIGNED_ONLY',
  UNASSIGNED_WITH_UNADDRESSED: 'UNASSIGNED_WITH_UNADDRESSED',
} as const;

export const OWNERSHIP_MODEL = {
  SINGLE: 'single',
  SHARED: 'shared',
} as const;

export const MESSAGE_PREFIX = {
  TEAM_NAME: 'teamName',
  OPERATOR_NAME: 'operatorName',
} as const;

// Mirrors BULK_CASE_ACTION_KIND on the server.
export const BULK_CASE_ACTION_KIND = {
  QUEUE_SET: 'queue.set',
  QUEUE_REMOVE: 'queue.remove',
} as const;

// Mirrors BULK_CASE_ACTION_MAX_SNAPSHOT on the server.
export const BULK_CASE_ACTION_MAX_SNAPSHOT = 10000;

export const BULK_QUEUE_RUN_STATUS = {
  COMPLETED: 'completed',
} as const;

export const BULK_QUEUE_RUN_ITEM_STATUS = {
  SKIPPED: 'skipped',
  FAILED: 'failed',
} as const;

export const CASE_TYPE = {
  CLAIM: 'CLAIM',
  SERVICE: 'SERVICE',
} as const;

export type CaseType = (typeof CASE_TYPE)[keyof typeof CASE_TYPE];

export type BulkCaseActionKind =
  (typeof BULK_CASE_ACTION_KIND)[keyof typeof BULK_CASE_ACTION_KIND];

export type MessagePrefix =
  (typeof MESSAGE_PREFIX)[keyof typeof MESSAGE_PREFIX];

export type OwnershipModel =
  (typeof OWNERSHIP_MODEL)[keyof typeof OWNERSHIP_MODEL];

export type SortType = (typeof SORT_TYPE)[keyof typeof SORT_TYPE];

export type CaseAvailabilityFilter =
  (typeof CASE_AVAILABILITY_FILTER)[keyof typeof CASE_AVAILABILITY_FILTER];

interface QueueModelConfig {
  sortType: SortType;
  caseAvailabilityFilter: CaseAvailabilityFilter;
}

export function getOwnershipModel(
  sortType?: string,
  caseAvailabilityFilter?: string,
): OwnershipModel {
  if (
    sortType === SORT_TYPE.CREATED_AT_FIRST &&
    caseAvailabilityFilter === CASE_AVAILABILITY_FILTER.UNASSIGNED_ONLY
  ) {
    return OWNERSHIP_MODEL.SINGLE;
  }
  return OWNERSHIP_MODEL.SHARED;
}

export function getQueueConfigForOwnership(
  model: OwnershipModel,
): QueueModelConfig {
  if (model === OWNERSHIP_MODEL.SINGLE) {
    return {
      sortType: SORT_TYPE.CREATED_AT_FIRST,
      caseAvailabilityFilter: CASE_AVAILABILITY_FILTER.UNASSIGNED_ONLY,
    };
  }
  return {
    sortType: SORT_TYPE.UNADDRESSED_FIRST,
    caseAvailabilityFilter:
      CASE_AVAILABILITY_FILTER.UNASSIGNED_WITH_UNADDRESSED,
  };
}

export function getWaitTimeLabel(
  caseAvailabilityFilter?: string,
): 'createdDate' | 'unaddressedTime' {
  if (caseAvailabilityFilter === CASE_AVAILABILITY_FILTER.UNASSIGNED_ONLY) {
    return 'createdDate';
  }
  return 'unaddressedTime';
}
